<template>
    <div class="row justify-content-center">
        <div class="col-md-7 col-11">
            <card>
                <template slot="header">
                    Change Password
                </template>
                <form class="form-horizontal">
                    <!-- NEW PASSWORD -->
                    <div class="row">
                        <label class="col-sm-2 col-form-label">New Password</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <el-input v-model="$store.state.user.newPassword" type="password"/>
                            </div>
                        </div>
                    </div>
                    <!-- NEW PASSWORD CONFIRMATION -->
                    <div class="row">
                        <label class="col-sm-2 col-form-label">New Password Confirmation</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <el-input v-model="$store.state.user.newPasswordConfirmation" type="password"/>
                            </div>
                        </div>
                    </div>
                </form>
                <div class="d-flex justify-content-end">
                    <el-button
                        type="btn btn-primary"
                        @click="submit()"
                        :loading="saving">
                            Save
                    </el-button>
                </div>
            </card>
        </div>
    </div>
</template>

<script>
import http from '../../http'

export default {
    data () {
        return {
            saving: false
        }
    },
    methods: {
        submit: async function () {
            try {
                this.saving = true
                const { data } = await http.put('/api/admin/user', this.$store.state.user)
                this.$store.state.user = data.user
                this.$notify('Information successfully updated!')
            } catch (e) {
                console.log(e)
                console.log('error saving account settings')
            }
            this.saving = false
        }
    }
}
</script>